import styled, { css } from 'styled-components';
import campaignHeading from 'Common/styles/campaignHeading';

import Course from 'Components/Search/Course/Course';
import { InputSearch, AutoComplete } from 'Components/Search/Course/Course.styled';
import { Input, Button } from 'Components/Search/Search.styled';

export const Container = styled.div<{ $journeyCourseSearch: boolean }>`
    ${({ theme, $journeyCourseSearch }) => css`
        position: relative;
        gap: 1rem;
        padding: 1.5rem 2rem 2rem 1.5rem;
        color: ${theme.colors.primaryContrast.hex};
        background: ${theme.colors.campaigns.clearing.primaryTintEighty.hex};
        flex-direction: column;
        border-radius: 0.5rem;

        ${!$journeyCourseSearch &&
        css`
            max-width: 100%;
            z-index: 2;
            margin: 0 auto;
            padding: 1rem;
            gap: 0;

            @media ${theme.breakpoints.medium.media} {
                margin: 0 auto 0 -2rem;
            }

            @media ${theme.breakpoints.large.media} {
                margin: 0 auto 0 -2.5rem;
                padding: 1.5rem 2rem 2rem 1.5rem;
                gap: 1rem;
            }
        `}
    `}
`;

export const CopyContainer = styled.div<{ $journeyCourseSearch: boolean }>`
    ${({ theme, $journeyCourseSearch }) => css`
        h2 + p,
        h3 + p {
            margin-top: 0rem;
        }

        @media ${theme.breakpoints.large.media} {
            width: ${$journeyCourseSearch ? '100%' : '75%'};
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        ${campaignHeading()};
        color: inherit;
        margin: 0rem 0rem 0.75rem;
        font-size: 1.5rem;

        @media ${theme.breakpoints.large.media} {
            margin: 0rem 0rem 0.75rem;
            font-size: 1.875rem;
        }
    `}
`;

export const StyledCourseSearch = styled(Course)`
    ${({ theme }) => css`
        width: 100%;

        ${Input} {
            border-radius: 0.25rem;
            border: none;
            padding: 0rem 0.75rem;

            ::placeholder {
                font-size: 1.125rem;
            }
        }

        ${Button} {
            background-color: ${theme.colors.accents[1].hex};
            border-radius: 0.25rem;
            width: 2.5rem;
        }

        ${InputSearch} {
            border-radius: 0.25rem;
        }

        ${AutoComplete} {
            border-radius: 0.25rem;
            box-shadow: none;
            border: ${theme.commonStyles.brandPixel} solid
                ${theme.colors.campaigns.clearing.secondary.hex};
        }
    `}
`;

export const SearchWrapper = styled.div<{ $journeyCourseSearch: boolean }>`
    ${({ theme, $journeyCourseSearch }) => css`
        display: flex;
        align-items: center;
        margin-right: ${$journeyCourseSearch ? '1rem' : '0'};

        @media ${theme.breakpoints.smallLarge.media} {
            width: 100%;
            width: ${$journeyCourseSearch ? '90%' : '100%'};
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.medium.media} {
            display: block;
            position: absolute;
            height: 7.95rem;
            width: 7.7rem;
            right: -1rem;
            top: -4.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            height: 10.4rem;
            width: 9.8rem;
            right: -2.8rem;
            top: -3.12rem;
        }
    `}
`;
